import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import * as React from 'react'
import { FunctionComponent, useContext, useState } from 'react'
import ImageIconProhibited from '../assets/images/icons/icon-prohibited.svg'
import ImageIconAllowed from '../assets/images/icons/icon-allowed.svg'

import i18n from 'i18next'
import { AudioContext, AudioContextType } from '../audioContext'
import {
  CookieConsent,
  FrontHeaderStyled,
  FrontPageContainerStyled, FrontPageContentLinePleasePaddingStyled,
  FrontPageContentLinePleaseStyled,
  FrontPageContentStyled, FrontPageCookieConsentPContainerPaddingStyled,
  FrontPageCookieConsentPContainerStyled,
  FrontPageImageContainerStyled,
  ImprintContainerStyled,
  PageNotFoundTextStyled,
  PStyled,
  TextButtonStyled,
  TextButtonStyledContainer
} from '../components/components'
import ImageDomkirche from '../assets/images/domkirche.svg'
import ImageIlluhowto from '../assets/images/illuhowto.svg'
import { languages } from '../i18n'
import { useCookieConsent } from '../utils/customHooks'
import { trackPageInteraction, usePageTracking } from '../utils/tracking'

export const useValidateLanguage = (lang) => {
  if (lang && languages.indexOf(lang) == -1) {
    return <PageNotFound></PageNotFound>
  }
}

export const FrontPage: FunctionComponent = (props) => {
  const { lang } = useParams()
  const { t } = useTranslation()
  const { acceptTerms, isUserExperienceCookiesAllowed, setIsUserExperienceCookiesAllowed } = useCookieConsent()
  const [isCookieConsentVisible, setIsCookieConsentVisible] = useState(false)
  const pageNotFound = useValidateLanguage(lang)
  const { audio, setShouldPlayOnStart } = useContext(AudioContext) as AudioContextType

  usePageTracking(isUserExperienceCookiesAllowed, 'FrontPage', lang)
  if (pageNotFound) {
    return <PageNotFound></PageNotFound>
  }

  const toggleCookieConsentVisibility = () => {
    setIsCookieConsentVisible(!isCookieConsentVisible)
  }

  return (
    <FrontPageContainerStyled>
      <FrontHeaderStyled>
        <div>
          <img src={ImageDomkirche} width="102" height="163" alt="Domkirche St. Stephan" />
          <h1>
            <span>AUDIOGUIDE</span>
            <span>Domkirche</span>
            <span>St.&#160;Stephan</span>
          </h1>
        </div>
      </FrontHeaderStyled>
      <FrontPageContentStyled>
        <FrontPageContentLinePleaseStyled>
          <div>
            <img alt="Don`t use speaker" src={ImageIconProhibited}></img>
            <span>{t('frontpage.please')}</span>
            <img alt="Do use earphone" src={ImageIconAllowed}></img>
          </div>
        </FrontPageContentLinePleaseStyled>
        <FrontPageContentLinePleasePaddingStyled></FrontPageContentLinePleasePaddingStyled>
        <FrontPageImageContainerStyled>
          <img src={ImageIlluhowto} width="315" height="247" alt="Infographic HowTo" />
        </FrontPageImageContainerStyled>
        <FrontPageCookieConsentPContainerPaddingStyled></FrontPageCookieConsentPContainerPaddingStyled>
        <FrontPageCookieConsentPContainerStyled>
          <PStyled>
            {t('frontpage.textCookies')} <a href="#" onClick={
            (e) => {
              setIsCookieConsentVisible(true)
              e.preventDefault()
            }}>{t('frontpage.linkCookies')}</a>
          </PStyled>
        </FrontPageCookieConsentPContainerStyled>
        <TextButtonStyledContainer>
          <TextButtonStyled onClick={() => {
            audio.load() // we do this for safari, by calling load (although src may not be set), we make sure, we can play audio later without a second click event of user
            setShouldPlayOnStart(false)
            acceptTerms()
            trackPageInteraction(isUserExperienceCookiesAllowed, 'frontPageOkButtonClick')
            // navigate(`/${i18n.resolvedLanguage}/station/1`, { replace: true })
          }}>
            {t('ui.btnStart')}
          </TextButtonStyled>
        </TextButtonStyledContainer>
        <ImprintContainerStyled>
          <div><a href="https://www.illustree.at" target="_blank">CREATED BY ILLUSTREE</a><span> • </span><a href="https://stephanskirche.at/impressum.php" target="_blank">IMPRESSUM</a></div>
        </ImprintContainerStyled>
      </FrontPageContentStyled>

      <CookieConsent
        isOpen={isCookieConsentVisible}
        isUserExperienceCookiesAllowed={isUserExperienceCookiesAllowed}
        setIsUserExperienceCookiesAllowed={setIsUserExperienceCookiesAllowed}
        onOkay={() => {
          setShouldPlayOnStart(false)
          acceptTerms()
          trackPageInteraction(isUserExperienceCookiesAllowed, 'frontPageOkButtonClick')
        }}
        onClose={toggleCookieConsentVisibility}
      />
    </FrontPageContainerStyled>
  )
}

export const PageNotFound: FunctionComponent = (props) => {
  const { t } = useTranslation()
  const { lang } = useParams()
  const navigate = useNavigate()
  const { isUserExperienceCookiesAllowed } = useCookieConsent()

  usePageTracking(isUserExperienceCookiesAllowed, 'PageNotFoundPage', lang ? lang : '')

  return (
    <>
      <FrontHeaderStyled small={true}>
        <div>
          <img src={ImageDomkirche} width="102" height="163" alt="Domkirche St. Stephan" />
          <h1>
            <span>AUDIOGUIDE</span>
            <span>Domkirche</span>
            <span>St.&#160;Stephan</span>
          </h1>
        </div>
      </FrontHeaderStyled>
      <PageNotFoundTextStyled>
        <p>{t('pageNotFound.title')}</p>
        <TextButtonStyledContainer>
          <TextButtonStyled onClick={() => {
            navigate(`/${i18n.resolvedLanguage}`, { replace: true })
          }}>{t('pageNotFound.btn')}</TextButtonStyled>
        </TextButtonStyledContainer>
      </PageNotFoundTextStyled>
    </>
  )
}
